import { FormContainerUserSignUp, FormTitle, Label, StyledInput, InputDiv, FormInfo, Details, FormLink } from '../../../reusable_ui/styles/Forms.styled' 
import { LogoImg } from '../../NavPage/styles/NavPage.styled'
import { FPFormControl } from './styles/ForgotPassword.user.styled'
import { InputButton } from '../../../reusable_ui/styles/Button.styled'

const UserReset = () => {
  

  return (
    <FormContainerUserSignUp>
       <LogoImg />
      
      <FPFormControl>
        <FormTitle>
          <span>Forget password</span>
          <p>Provide your registered email address to reset</p>
        </FormTitle>
        <InputDiv>
          <Label>Email address</Label>
          <StyledInput type='email' />
        </InputDiv>
        <InputButton>Reset</InputButton>
        <FormInfo>
          <Details>Remember password? <FormLink to='/user/login'>Login</FormLink></Details>         
        </FormInfo>
      </FPFormControl>
    </FormContainerUserSignUp>
  )
}

export default UserReset